module.exports = __webpack_public_path__ + "04_short_gold.cca4d26a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/04_short_gold.png
// module id = CidD
// module chunks = 0